/**
 * 开发环境下组件演示
 */


import Layout from './modules/layout'

const devComponents = []

if (process.env.NODE_ENV === 'development') {
  devComponents.push(...[{
    path: '/demo',
    name: 'Demo',
    component: Layout,
    redirect: 'noredirect',
    alwaysShow: true,
    meta: {
      groupTitle: '测试Dome',
      title: 'Demo(test)',
      icon: 'tmp',
    },
    children: [
      {
        path: 'DEV_button',
        name: 'DEV_Button',
        component: () => import(/* webpackChunkName: "dev-button" */'@v/demo/button'),
        meta: {
          title: '按钮',
        },
      },
      {
        path: 'DEV_webfont',
        name: 'DEV_Webfont',
        component: () => import(/* webpackChunkName: "dev-webfont" */'@v/demo/webfont'),
        meta: {
          title: '字体',
        },
      },
      {
        path: 'DEV_textareaauto',
        name: 'DEV_TextareaAuto',
        component: () => import(/* webpackChunkName: "dev-textareaAuto" */'@v/demo/TextareaAuto'),
        meta: {
          title: '输入',
        },
      },
      {
        path: 'DEV_uploadimg',
        name: 'DEV_UploadImg',
        component: () => import(/* webpackChunkName: "dev-upload" */'@v/demo/uploadImg'),
        meta: {
          title: '图片上传',
        },
      },
      // {
      //   path: 'DEV_iframe',
      //   name: 'DEV_Iframe',
      //   component: () => import(/* webpackChunkName: "dev-iframe" */'@v/demo/iframe'),
      //   meta: {
      //     title: 'iframe'
      //   }
      // },
      {
        path: 'DEV_input',
        name: 'DEV_ztinput',
        component: () => import(/* webpackChunkName: "dev-extinput" */'@v/demo/ztinput'),
        meta: {
          title: 'input输入框',
        },
      },
      {
        path: 'DEV_eltabs',
        name: 'DEV_eltabs',
        component: () => import(/* webpackChunkName: "dev-eltabs" */'@v/demo/eltabs'),
        meta: {
          title: 'tabs切换',
        },
      },
      {
        path: 'DEV_eltable',
        name: 'DEV_eltable',
        component: () => import(/* webpackChunkName: "dev-eltabs" */'@v/demo/eltable'),
        meta: {
          title: 'table表格',
        },
      },
      {
        path: 'DEV_elform',
        name: 'DEV_elform',
        component: () => import(/* webpackChunkName: "dev-elform" */'@v/demo/elform'),
        meta: {
          title: 'form表单',
        },
      },
      {
        path: 'DEV_ztradiogroup',
        name: 'DEV_ztradiogroup',
        component: () => import(/* webpackChunkName: "dev-ztradiogroup" */'@v/demo/ztRadioGroup'),
        meta: {
          title: 'Radio单选框',
        },
      },
    ],
  }])
}


export default devComponents
